import Button from './button';
import { ArrowRight } from '../Icons/Icons';

interface InfoBannerProps {
  title: string;
  description: string;
  buttonTitle: string;
  buttonUrl: string;
}

export default function InfoBanner({
  title,
  description,
  buttonTitle,
  buttonUrl,
}: InfoBannerProps) {
  return (
    <div className="flex w-[70%] flex-col items-center self-center">
      {title && <h2 className="cs-h2-2xl">{title}</h2>}

      {description && (
        <span
          className="cs-l-body text-[var(--Text-Default-Light)]"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}

      {buttonTitle && buttonUrl && (
        <Button
          className="mt-8 w-full"
          title={buttonTitle}
          url={buttonUrl}
          icon={<ArrowRight className="text-[var(--Text-Inverse-Strong)]" width={20} height={20} />}
        />
      )}
    </div>
  );
}
